<div class="p-grid" style="padding: 15px;">
    <p-dropdown [appendTo]="'body'" [options]="listeOp" [(ngModel)]="selectedOp" placeholder="Selectionnez l'operateur" class="p-col-9" [style]="{'width': '100%'}"></p-dropdown>
    <p-button  type="button"  icon="pi pi-user-plus"  class="btn-info p-col-3" label="Affecter" [style]="{'width': '100%'}" (click)="affecterFiche()"></p-button>
</div>